import { useAsync, useCookie } from 'react-use'

import type { Nullable } from '@/types/prelude.type'
import { API_KEY } from '@/config/api'
import { env } from '@/config/env'
import { UserProfile } from '@/types/user'

const userProfilesCache = new Map<string, Promise<Nullable<UserProfile>>>()

type UserProfileFetcherOptions = {
  forceRequest?: boolean
}

export async function fetchCurrentUserProfile(
  accessToken: Nullable<string>,
  options: UserProfileFetcherOptions = {}
): Promise<Nullable<UserProfile>> {
  const { forceRequest = false } = options
  if (!accessToken || !API_KEY) {
    return null
  }
  if (!forceRequest && userProfilesCache.has(accessToken)) {
    return userProfilesCache.get(accessToken)
  }

  const URL = `${env.GIPHY_VALIDATE_TOKEN_URL}?access_token=${accessToken}&api_key=${API_KEY}`
  const request = new Promise<Nullable<UserProfile>>((resolve) => {
    fetch(URL)
      .then((resp) => resp.json())
      .then((json) => (json?.meta?.status === 200 ? json?.data?.profile : null))
      .then(resolve)
      .catch((e) => {
        console.error(e)
        resolve(null)
      })
  })

  userProfilesCache.set(accessToken, request)
  return request
}

export function useCurrentUserProfile() {
  const [accessToken] = useCookie('access_token')
  const state = useAsync(async () => fetchCurrentUserProfile(accessToken), [accessToken])

  return {
    data: state.value,
    error: state.error,
    loading: state.loading,
  }
}
